export const NAV_ITEMS = [
  { target: "about", title: "Om oss" },
  { target: "offer", title: "Erbjudande" },
  { target: "naas", title: "Tjänster" },
  { target: "career", title: "Karriär" },
  { target: "employees", title: "Medarbetare" },
];

// Sektions-id (id-attributet i DOM:en) -> permalänk. Ordningen ska matcha ordningen på sidan,
// eftersom scroll-spyn i App.js går igenom dem uppifrån och ned.
export const SECTION_PATHS = {
  home: "/",
  about: "/about",
  offer: "/offer",
  naas: "/naas",
  career: "/career",
  employees: "/team",
  contact: "/contact",
};

// top/right är kontorets position i procent av Sverigekartan (Mercator, räknat från lat/long)
export const OFFICES = [
  { name: "Stockholm", street: "Östermalmsgatan 26A", zip: "114 26", maps: "https://maps.app.goo.gl/JyhzREq5PABrRaZC9", top: "73%", right: "47%" },
  { name: "Västerås", street: "Tallmätargatan 1", zip: "721 34", maps: "https://maps.app.goo.gl/hPpMDsCqvru7k7aM6", top: "71.4%", right: "56.1%" },
  { name: "Falun", street: "Sturegatan 87", zip: "791 60", maps: "https://maps.app.goo.gl/BCnFEFJ8LLyMsw9q9", top: "65.3%", right: "61.6%" },
];
